export default "__VITE_ASSET__EzcKCHdu__"